export default "__VITE_ASSET__CtoDW3eg__"